import { decomposeOid } from '@verdant-web/common';
export class PersistenceDocuments {
    constructor(db, ctx) {
        this.db = db;
        this.ctx = ctx;
        this.reset = this.db.reset.bind(this.db);
        this.close = this.db.close.bind(this.db);
        this.saveEntities = async (entities, options) => {
            if (entities.length === 0)
                return;
            // filter entities to remove collections which don't
            // exist in the schema anymore
            const currentCollectionSet = new Set(Object.keys(this.ctx.schema.collections));
            const collections = [];
            const filteredEntities = entities.filter((entity) => {
                const { collection } = decomposeOid(entity.oid);
                if (!currentCollectionSet.has(collection)) {
                    this.ctx.log('warn', `Entity ${entity.oid} is in a collection that no longer exists in the schema. It will not be saved.`);
                    return false;
                }
                if (!collections.includes(collection))
                    collections.push(collection);
                return true;
            });
            if (collections.length === 0)
                return;
            this.ctx.log('debug', 'Saving', filteredEntities.length, 'entities');
            await this.db.saveEntities(filteredEntities, {
                abort: options === null || options === void 0 ? void 0 : options.abort,
                collections,
            });
            this.ctx.log('debug', 'Saved', filteredEntities.length, 'entities');
            this.ctx.entityEvents.emit('collectionsChanged', collections);
            for (const entity of entities) {
                this.ctx.entityEvents.emit('documentChanged', entity.oid);
            }
        };
        this.findOneOid = this.db.findOneOid.bind(this.db);
        this.findAllOids = this.db.findAllOids.bind(this.db);
        this.stats = this.db.stats.bind(this.db);
    }
}
//# sourceMappingURL=PersistenceQueries.js.map